import { render, staticRenderFns } from "./SubHeaderSection.vue?vue&type=template&id=549d6236&scoped=true&"
import script from "./SubHeaderSection.vue?vue&type=script&lang=js&"
export * from "./SubHeaderSection.vue?vue&type=script&lang=js&"
import style0 from "./SubHeaderSection.vue?vue&type=style&index=0&id=549d6236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549d6236",
  null
  
)

export default component.exports